export const COOKIE_CONSENT_KEY = 'cookieConsent';

export type CookieConsentChoice = 'all' | 'necessary' | 'declined';

/** `undefined` until the first read, then the session's choice (including a storage miss). */
let memoryChoice: CookieConsentChoice | null | undefined;

function isChoice(value: unknown): value is CookieConsentChoice {
  return value === 'all' || value === 'necessary' || value === 'declined';
}

export function getCookieConsent(): CookieConsentChoice | null {
  if (memoryChoice !== undefined) return memoryChoice;
  if (typeof window === 'undefined') return null;

  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    memoryChoice = isChoice(stored) ? stored : null;
  } catch {
    memoryChoice = null;
  }

  return memoryChoice;
}

export function hasTrackingConsent(): boolean {
  const choice = getCookieConsent();
  return choice === 'all' || choice === 'necessary';
}

export function isTrackingDeclined(): boolean {
  return getCookieConsent() === 'declined';
}

export function setCookieConsent(choice: CookieConsentChoice): void {
  memoryChoice = choice;
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, choice);
  } catch {
    // The in-memory choice still applies for this page load.
  }
}
